// @ts-nocheck
import React from "react";
import { Table, Button } from "antd";
import BaseComponent from "../../../../../base/common/BaseComponent";

class ChangeHistoryListTable extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      expandedRowKeys: [],
    };
  }

  handleTableChange = (pagination: any, filters: any, sorter: any) => {
    const tableFilter = filters;
    const tableSorter = sorter;
    let filterArr: any[] = [];
    let sort = null;

    if (Object.values(tableFilter).some((value) => value !== null)) {
      filterArr = Object.entries(tableFilter)
        .filter(([key, value]) => value !== null)
        .map(([key, value]) => {
          return {
            filterColumn: this.props.tableFilterMap.get(key),
            filterValue: value,
          };
        });
    }

    if (Object.keys(tableSorter).length !== 0 && tableSorter.column !== undefined) {
      sort = {
        sortColumn: tableSorter.column.sortName ?? tableSorter.column.dbName,
        isAscending: tableSorter.order === "ascend" ? true : false,
      };
    }

    this.props.handleFilterSort(filterArr, sort, filters);
  };

  handleExpand = (record: any) => {
    const { expandedRowKeys } = this.state;
    const isExpanded = expandedRowKeys.includes(record.procedureID);
    if (isExpanded) {
      this.setState({
        expandedRowKeys: expandedRowKeys.filter((key: any) => key !== record.procedureID),
      });
    } else {
      this.setState({
        expandedRowKeys: [...expandedRowKeys, record.procedureID],
      });
    }
  };

  renderContainerRow = (record: any) => (
    <tr key={record.procedureID}>
      <td colSpan={100}>
        <div>
          {record.procedureHeader}
          <Button
            onClick={() => this.handleExpand(record)}
            data-testid={`change-history-expand-btn-${record.procedureID}`}
          >
            Expand
          </Button>
        </div>
      </td>
    </tr>
  );

  render() {
    const { data, columns, tab } = this.props;
    const filteredColumns = columns.filter((column: any) => !column.hidden);
    return (
      // @ts-ignore
      <Table
        key={this._generateGUID()}
        columns={filteredColumns}
        dataSource={data}
        pagination={false}
        onChange={this.handleTableChange}
        className={tab === 1 ? "changeHistoryTableGroup" : "changeHistoryTable"}
        rowClassName={(record) =>
          record.isLeaveProcedure ? "archiveChangeHistory" : "activeChangeHistory"
        }
        testid="change-history-table"
        rowTestId={(record: any) =>
          `change-history-row-${record.historyId ?? record.id ?? record.procedureID}`
        }
        defaultExpandAllRows={true}
        locale={{
          emptyText: "",
        }}
      />
    );
  }
}

export default ChangeHistoryListTable;
